import type { FilterModule } from "../index";
import { FinancingEventsFilter } from "./FinancingEventsFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import {
  defaultFinancingEventsSlice,
  type FinancingEventsSlice,
} from "./slice";

export type { FinancingEventsSlice } from "./slice";
export { defaultFinancingEventsSlice } from "./slice";

export const financingEventsModule: FilterModule<FinancingEventsSlice> = {
  key: "financingEvents",
  defaultSlice: defaultFinancingEventsSlice,
  Component: FinancingEventsFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
